import { SyntheticEvent, useRef, useState, ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { Menu as PrimeMenu, MenuProps } from 'primereact/menu';
import { Icon } from '../icon';
import classes from './menu.module.scss';
import cn from 'classnames';

type TMenuProps = Omit<MenuProps, 'popup'> & {
  label: string;
};

type TTemplateType = {
  icon: ReactNode;
  label: string;
  command?: (event: SyntheticEvent) => void;
};

export const Menu = ({ model, ...props }: TMenuProps) => {
  const menu = useRef<any>(null);
  const [isOpen, setIsOpen] = useState(false);
  const { formatMessage } = useIntl();

  const openMenu = (e: SyntheticEvent) => {
    if (menu?.current?.toggle) return menu?.current?.toggle(e);
  };

  const onShow = (e: SyntheticEvent) => {
    if (props.onShow) {
      props.onShow(e);
    }
    setIsOpen(true);
  };

  const onHide = (e: SyntheticEvent) => {
    if (props.onHide) {
      props.onHide(e);
    }
    setIsOpen(false);
  };

  const template = ({ icon, command, label }: TTemplateType) => (
    <div onClick={command} className={classes.template_wrapper}>
      {icon}
      {label}
    </div>
  );

  const modelTransformer = (model: MenuProps['model']) =>
    model?.map((item) => (item?.template ? item : { template, ...item }));

  return (
    <>
      <PrimeMenu
        ref={menu}
        popup
        className={cn(classes.root)}
        onShow={onShow}
        onHide={onHide}
        model={modelTransformer(model)}
        {...props}
      />
      <div onClick={openMenu} className={classes.label_wrapper}>
        <span>{formatMessage({ id: props.label })}</span>
        <div
          className={cn(
            classes.chevron,
            isOpen ? classes.chevron_up : classes.chevron_down
          )}
        >
          <Icon
            glyph={Icon.glyphs.font['pi-chevron-down']}
            size={Icon.sizes.tiny}
          />
        </div>
      </div>
    </>
  );
};
